import config from 'cio/config/environment';
import { OAuthOpenOptions, OAuthProvider, Provider } from 'cio/utils/oauth';

interface OpenOptions extends OAuthOpenOptions {
  hostedDomain?: string;
  loginHint?: string;
}

export default class GoogleOIDCOauth extends OAuthProvider {
  name = Provider.GoogleOIDC;
  baseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
  clientId = config.oAuth.googleOidc.clientId;
  scope = 'email openid';
  extraParams: OAuthProvider['extraParams'] = {
    access_type: 'offline',
    include_granted_scopes: true,
  };

  async open(options: OpenOptions = {}) {
    let dynamicParams: Record<string, string> = {};

    if (options?.hostedDomain) {
      dynamicParams.hd = options?.hostedDomain;
    }

    if (!options?.hostedDomain || options?.hostedDomain === '*') {
      dynamicParams.prompt = 'select_account';
    }

    if (options?.loginHint) {
      dynamicParams.login_hint = options?.loginHint;
    }

    let res = await super.open({ ...options, ...dynamicParams });

    return res;
  }
}
